import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import {
    deltaValue,
    getBaseValue,
    // getKpiReportFromGQResult,
    getValue,
    // KpiReport,
    // KpiReportEntity,
    roundValue,
    Unit
} from "../processors";
// import { queryEntities } from "../misc";
import { FigureSolidDashKpiProvider } from "./categoryChartData.types";
import _ from "lodash";
import { getKpisForProvidersWithCategoryChart } from "../../Components/opendata";
import { figureDeltaString } from "./figureDeltaString";
import { VALUE_STATUS_NAMING } from "../../Components/misc";

export const fetchFigureChartData: CategoryChartQueryFn = async ({
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProvider> => {
    const provider = providers?.[0];
    const kpi = kpis?.[0];
    if (!provider || !categoryChart || kpi == null) return null;

    let kpiReportResults = await getKpisForProvidersWithCategoryChart([kpi], [provider], false, categoryChart);

    if (!kpiReportResults) return null;

    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    // kpi report results for the provider
    const providerKpiReportResults = _.uniqBy(
        kpiReportResults?.filter(d => d?.provider?.tid === provider?.tid) ?? [],
        d => d.year
    );

    if (!providerKpiReportResults || !providerKpiReportResults?.length) return null;

    const { displayTitle, visType, figureHeader, figureFooter } = categoryChart;

    // find unit, last year and previous year data
    const years = _.orderBy(
        _.uniq(providerKpiReportResults?.map(d => d.year)?.filter(d => d != null) ?? []),
        d => d,
        "desc"
    );

    const latestYear = years?.[0];
    const previousYear = years?.[1];

    const latestYearResult = kpiReportResults?.filter(d => latestYear != null && d.year === latestYear) ?? [];
    const previousYearResult = kpiReportResults?.filter(d => previousYear != null && d.year === previousYear) ?? [];
    const latestYearValues = latestYearResult.filter(d => d?.value != null);
    const previousYearValues = previousYearResult.filter(d => d?.value != null);

    const latestYearBaseValues = latestYearValues.map(d => getBaseValue(d.value, d.unit));
    const previousYearBaseValues = previousYearValues.map(d => getBaseValue(d.value, d.unit));
    const latestYearBaseUnits = _.uniq(latestYearBaseValues.map(d => d.unit));
    const previousYearBaseUnits = _.uniq(previousYearBaseValues.map(d => d.unit));

    // let previousYearUnit: Unit = null;
    let unit: Unit =
        latestYearBaseUnits?.length > 1 ||
        previousYearBaseUnits?.length > 1 ||
        (latestYearBaseUnits?.length === 1 &&
            previousYearBaseUnits?.length === 1 &&
            latestYearBaseUnits?.[0] !== previousYearBaseUnits?.[0])
            ? null
            : latestYearBaseUnits[0];

    let latestYearValue: number = null;
    let latestYearValueStatus: string = null;

    let latestYearBaseValue: number = null;
    let previousYearValue: number = null;
    let previousYearBaseValue: number = null;

    // const yearAscKpiResults = _.orderBy(providerKpiReportResults, ["year", "asc"]);
    // const latestYearData = yearAscKpiResults?.[yearAscKpiResults.length - 1];
    // const previousYearData = yearAscKpiResults?.[yearAscKpiResults.length - 2];

    // const { year: latestYear, value: latestYearValue } = latestYearData ?? {};

    // if (latestYear == null) return null;

    const kpiCode = kpi[0];
    const schemeType = kpi[1];
    const agg = kpi[2] ?? "sum";

    if (agg === "count") {
        latestYearValue = latestYearValues.length;
        previousYearValue = latestYearValues.length;
        latestYearBaseValue = latestYearValue;
        previousYearBaseValue = previousYearValue;

        unit = "Count";
        // previousYearUnit = "Count";
    } else if (_?.[agg]) {
        latestYearBaseValue =
            latestYearBaseValues?.length > 0 ? _?.[`${agg}`](latestYearBaseValues.map(d => d.value)) : null;
        previousYearBaseValue =
            previousYearBaseValues?.length > 0 ? _?.[`${agg}`](previousYearBaseValues.map(d => d.value)) : null;

        // resolve units and values
        if (latestYearBaseValue != null) {
            const { unit: tempUnit, value: tempValue1 } = roundValue(latestYearBaseValue, unit);
            latestYearValue = tempValue1;
            unit = tempUnit as Unit;
        } else {
            latestYearValueStatus = latestYearResult?.filter(d => d?.value == null)?.[0]?.valueStatus;
        }

        if (previousYearBaseValue != null) {
            const { value: tempValue1 } = roundValue(previousYearBaseValue, unit);
            previousYearValue = tempValue1;
            // previousYearUnit = tempUnit as Unit;
        }
    }
    // else {
    //     latestYearBaseValue = latestYearBaseValues?.length > 0 ? _.sum(latestYearBaseValues.map(d => d.value)) : null;
    //     previousYearBaseValue =
    //         previousYearBaseValues?.length > 0 ? _.sum(previousYearBaseValues.map(d => d.value)) : null;

    //     // resolve units and values
    //     if (latestYearBaseValue != null) {
    //         const { unit: tempUnit, value: tempValue1 } = roundValue(latestYearBaseValue, unit);
    //         latestYearValue = tempValue1;
    //         unit = tempUnit as Unit;
    //     }

    //     if (previousYearBaseValue != null) {
    //         const { value: tempValue1 } = roundValue(previousYearBaseValue, unit);
    //         previousYearValue = tempValue1;
    //         // previousYearUnit = tempUnit as Unit;
    //     }
    // }

    if (latestYear == null) {
        return null;
    }

    // find deal of values between latest year and previous year
    const delta = deltaValue(previousYearBaseValue, latestYearBaseValue, unit);

    // previousYearValues.length === 0
    //     ? 0
    //     : (previousYearValue ?? 0) === 0
    //     ? 100
    //     : _.round(((latestYearValue - previousYearValue) / previousYearValue) * 100, 1);

    const deltaString = figureDeltaString(delta, category);

    // create content for header and footer of the figure
    const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
        year: latestYear,
        value: latestYearValue,
        deltaString
    });

    const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
        year: latestYear,
        value: latestYearValue,
        deltaString
    });

    const ret: FigureSolidDashKpiProvider = {
        unit: unit as Unit,
        year: latestYear,
        waterProvider: provider,
        kpiCode,
        schemeType,
        title: displayTitle,
        footer: null,
        figure: !(
            (visType === "figure")
            // || visType === "figureWithSolidDashLine" || visType === "figureWithStackHorBarChart")
        )
            ? null
            : {
                  unit: latestYearValue != null ? (roundValue(latestYearValue, unit as Unit).unit as Unit) : null,
                  decimals: latestYearValue != null ? roundValue(latestYearValue, unit as Unit).decimals : 0,
                  header:
                      !figureHeader || figureHeader.processed.trim() === ""
                          ? null
                          : {
                                processed: figureHeaderProcessed,
                                value: figureHeaderProcessed,
                                format: figureHeaderProcessed
                            },

                  value:
                      latestYearValue != null
                          ? getValue(latestYearValue, unit as Unit)
                          : latestYearValueStatus != null
                          ? VALUE_STATUS_NAMING?.[latestYearValueStatus] ?? latestYearValueStatus
                          : previousYearValue != null
                          ? VALUE_STATUS_NAMING.MD
                          : VALUE_STATUS_NAMING.NR,
                  footer:
                      !figureFooter || figureFooter.processed.trim() === ""
                          ? null
                          : {
                                processed: figureFooterProcessed,
                                value: figureFooterProcessed,
                                format: figureFooterProcessed
                            }
              },
        graph: null
    };

    return ret;
};
